const p = (file) => `${process.env.PUBLIC_URL}/imagemesprojets/${file}`;

// Pour chaque projet : `place`, `year`, `description` et `facts` (fiche technique).
// Les champs vides ne sont simplement pas affichés.
const projets = [
  {
    slug: 'ssr-lauriers-roses',
    name: {
      fr: 'Soins de Suite et Réadaptation des Lauriers Roses',
      en: 'Lauriers Roses Rehabilitation Care Centre',
    },
    type: { fr: 'Santé', en: 'Healthcare' },
    place: 'Levens',
    year: '2013',
    description: {
  fr: "Construction du centre de Soins de Suite et de Réadaptation Les Lauriers Roses à Levens, dans les Alpes-Maritimes. Ce projet architectural associe une structure en bois, des plans elliptiques et des exigences de qualité environnementale QEB et de performance énergétique BBC.",
  en: "Construction of the Les Lauriers Roses post-acute and rehabilitation care centre in Levens, in the Alpes-Maritimes. This architectural project combines timber construction, elliptical plans and QEB environmental quality and BBC energy performance standards.",
},
    facts: [
      { label: { fr: "Maître d'ouvrage", en: 'Client' }, value: { fr: 'Association « Chaîne de Vies 06 »', en: 'Association “Chaîne de Vies 06”' } },
      { label: { fr: 'Mission', en: 'Scope' }, value: { fr: "Maîtrise d'œuvre complète", en: 'Full project management' } },
      { label: { fr: 'Type de bâtiment', en: 'Building type' }, value: { fr: "Établissement recevant du public, service public et d'intérêt collectif (type U)", en: 'Public-service facility (type U)' } },
      { label: { fr: 'Surface', en: 'Floor area' }, value: { fr: '4 200 m²', en: '4,200 m²' } },
      { label: { fr: 'Montant des travaux', en: 'Works cost' }, value: { fr: '12 000 000 € HT', en: '€12,000,000 excl. VAT' } },
      { label: { fr: 'Performance', en: 'Performance' }, value: { fr: 'QEB & BBC', en: 'QEB & BBC' } },
    ],
    cover: p('LR_4.jpg'),
    gallery: [p('LR_4.jpg'), p('SSRLR_2.jpg'), p('SSRLR_5.jpg'), p('SSRELLR.png')],
  },
  {
    slug: 'ehpad-lauriers-roses',
    name: { fr: 'Ehpad Les Lauriers Roses', en: 'Les Lauriers Roses Nursing Home' },
    type: { fr: 'Médico-social', en: 'Care home' },
    place: 'Levens',
    year: '',
    description: {
  fr: "Découvrez le projet de l'EHPAD Les Lauriers Roses à Levens, dans les Alpes-Maritimes, présenté parmi les réalisations de Fiat Architecte.",
  en: "Discover the Les Lauriers Roses nursing home project in Levens, in the Alpes-Maritimes, featured among Fiat Architecte's architectural projects.",
},
    facts: [],
    cover: p('EHPAD_LR.jpg'),
    gallery: [p('EHPAD_LR.jpg'), p('ELR.png')],
  },
  {
    slug: 'ecole-leon-montier',
    name: {
      fr: 'École primaire Léon Montier',
      en: 'Léon Montier Primary School',
    },
    type: { fr: 'Éducation', en: 'Education' },
    place: 'Théoule-sur-Mer',
    year: '',
    description: {
  fr: "Découvrez le projet de l'école primaire Léon Montier à Théoule-sur-Mer, dans les Alpes-Maritimes, présenté parmi les réalisations de Fiat Architecte.",
  en: "Discover the Léon Montier primary school project in Théoule-sur-Mer, in the Alpes-Maritimes, featured among Fiat Architecte's architectural projects.",
},
    facts: [],
    cover: p('EPLMTM_1.jpg'),
    gallery: [
      p('EPLMTM_1.jpg'),
      p('EPLMTM_2.jpg'),
      p('EPLMTM_3.jpg'),
      p('EPLMTM_4.jpg'),
      p('EPLMTM.jpg'),
    ],
  },
  {
    slug: 'ecole-saint-thomas-d-aquin',
    name: {
      fr: "Travaux et extensions de l'école Saint Thomas d'Aquin",
      en: "Works and extension of Saint Thomas d'Aquin School",
    },
    type: { fr: 'Éducation', en: 'Education' },
    place: '',
    year: '',
description: {
  fr: "Découvrez les travaux et extensions de l'école Saint-Thomas-d'Aquin à Nice, dans les Alpes-Maritimes, présentés parmi les réalisations de Fiat Architecte.",
  en: "Discover the renovation and extension works at Saint Thomas d'Aquin School in Nice, in the Alpes-Maritimes, featured among Fiat Architecte's architectural projects.",
},    facts: [],
    cover: p('ESTA.png'),
    gallery: [p('ESTA.png')],
  },
];

export default projets;